(function() { window.GUID_bcd130a0_193c_4b2b_abe4_97256db59f0b = { getGuid: function() { return "bcd130a0-193c-4b2b-abe4-97256db59f0b"; } }; })();
/**
 * Labels of the results, rendered by the server so that every translation keeps living
 * in the resource files rather than in this script.
 */
class ScoreSheetFinderLabels {
    constructor() { }
    /** Forgets the labels, so that they are read again from the next content loaded. */
    static reset() {
        ScoreSheetFinderLabels.labels = undefined;
    }
    static get(key) {
        var _a, _b;
        if (ScoreSheetFinderLabels.labels == null) {
            ScoreSheetFinderLabels.labels =
                (_a = ScoreSheetFinderResults.readJson("#scoreSheetFinderLabels")) !== null && _a !== void 0 ? _a : {};
        }
        return (_b = ScoreSheetFinderLabels.labels[key]) !== null && _b !== void 0 ? _b : "";
    }
}
ScoreSheetFinderLabels.labels = undefined;
/**
 * Presentation of the results.
 *
 * The store owns the results and computes what has to be shown; this class only draws
 * it. The list and the cards are two renderings of the very same collection, so the
 * cards have no search logic of their own.
 */
class ScoreSheetFinderResults {
    constructor() { }
    static get $results() {
        return $(".scoresheet-finder__results");
    }
    static get $list() {
        return $("#scoreSheetFinderResultsList");
    }
    static get $grid() {
        return $("#scoreSheetFinderResultsGrid");
    }
    static get $columns() {
        return $("#scoreSheetFinderResultsColumns");
    }
    static get $header() {
        return $("#scoreSheetFinderResultsHeader");
    }
    static get $body() {
        return $("#scoreSheetFinderResultsBody");
    }
    static get $cards() {
        return $("#scoreSheetFinderResultsCards");
    }
    static get $pager() {
        return $("#scoreSheetFinderResultsPager");
    }
    static get $emptyState() {
        return $(".scoresheet-finder__empty-state-message");
    }
    static get store() {
        return ScoreSheetFinderStore.instance;
    }
    /** Reads a block of JSON rendered by the server. */
    static readJson(selector) {
        try {
            const text = $(selector).text();
            if (!text || !text.trim().length) {
                return undefined;
            }
            return JSON.parse(text);
        }
        catch (error) {
            console.error(`Error while reading ${selector}`, error);
            return undefined;
        }
    }
    /** Results rendered by the server, which seed the store. */
    static get initialResults() {
        const results = ScoreSheetFinderResults.readJson("#scoreSheetFinderInitialResults");
        return Array.isArray(results) ? results : [];
    }
    /** Reads what the server rendered and draws the shell of the list. */
    static setUp() {
        var _a;
        try {
            ScoreSheetFinderLabels.reset();
            ScoreSheetFinderResults.columns =
                (_a = ScoreSheetFinderResults.readJson("#scoreSheetFinderColumns")) !== null && _a !== void 0 ? _a : [];
            ScoreSheetFinderResults.cardsResults = [];
            ScoreSheetFinderResults.renderedCards = 0;
            ScoreSheetFinderResults.cardsAreStale = true;
            ScoreSheetFinderResults.renderColumns();
            ScoreSheetFinderResults.renderPagerShell();
        }
        catch (error) {
            console.error("Error while setting up the results", error);
        }
    }
    /**
     * Draws everything the results are made of. Filters are always applied right away,
     * so this runs on every change of the state, without any explicit apply step.
     */
    static render() {
        try {
            const store = ScoreSheetFinderResults.store;
            const results = store.sortedResults;
            const pageInfo = store.getPageInfo(results.length);
            // The page may have been clamped, so the state follows what is drawn.
            store.page = pageInfo.page;
            ScoreSheetFinderResults.renderRows(store.getPageResults(results));
            ScoreSheetFinderResults.renderCards(results);
            ScoreSheetFinderResults.renderPager(pageInfo);
            ScoreSheetFinderResults.renderHeaderState();
            ScoreSheetFinderResults.renderEmptyState(results.length === 0);
        }
        catch (error) {
            console.error("Error while rendering the results", error);
        }
    }
    /** Shows the list or the cards, depending on the format that is asked for. */
    static renderFormat() {
        try {
            const store = ScoreSheetFinderResults.store;
            const isCards = store.filters.format.value === "cards";
            ScoreSheetFinderResults.$list.toggleClass("hiddenforced", isCards);
            ScoreSheetFinderResults.$cards.toggleClass("hiddenforced", !isCards);
            const results = store.sortedResults;
            if (isCards && ScoreSheetFinderResults.cardsAreStale) {
                ScoreSheetFinderResults.cardsAreStale = false;
                ScoreSheetFinderResults.renderNextCards();
            }
            ScoreSheetFinderResults.renderEmptyState(results.length === 0);
        }
        catch (error) {
            console.error("Error while rendering the results format", error);
        }
    }
    // ---------------------------------------------------------------- columns
    static renderColumns() {
        const $columns = ScoreSheetFinderResults.$columns;
        const $header = ScoreSheetFinderResults.$header;
        if (!$columns.length || !$header.length) {
            return;
        }
        const titles = [];
        const filters = [];
        const cols = [];
        ScoreSheetFinderResults.columns.forEach(function (column) {
            const $col = $("<col />");
            $col.attr("data-field", column.field);
            $col.css("width", `${column.width}px`);
            cols.push($col[0]);
            titles.push(ScoreSheetFinderResults.buildHeaderCell(column)[0]);
            filters.push(ScoreSheetFinderResults.buildFilterCell(column)[0]);
        });
        $columns.empty().append(cols);
        const $titleRow = $('<tr class="ssf-grid__header-row"></tr>').append(titles);
        const $filterRow = $('<tr class="ssf-grid__filter-row"></tr>').append(filters);
        $header.empty().append($titleRow).append($filterRow);
        ScoreSheetFinderResults.renderHeaderState();
    }
    static buildHeaderCell(column) {
        const $cell = $('<th class="ssf-grid__header"></th>');
        $cell.attr("data-field", column.field);
        $cell.attr("draggable", "true");
        if (column.sortable) {
            $cell.addClass("ssf-grid__header--sortable");
        }
        $cell.append($('<span class="ssf-grid__header-title"></span>').text(column.title));
        if (column.sortable) {
            $cell.append($('<span class="ssf-grid__sort-indicator"></span>'));
        }
        $cell.append($('<span class="ssf-grid__resizer"></span>'));
        return $cell;
    }
    static buildFilterCell(column) {
        const $cell = $('<th class="ssf-grid__filter"></th>');
        $cell.attr("data-field", column.field);
        if (!column.filterable) {
            return $cell;
        }
        const $input = $('<input type="text" class="ssf-grid__filter-input" />');
        $input.attr("data-field", column.field);
        $input.attr("aria-label", column.title);
        const $clear = $('<button type="button" class="ssf-grid__filter-clear"></button>');
        $clear.attr("data-field", column.field);
        $clear.attr("title", ScoreSheetFinderLabels.get("clear"));
        $clear.attr("aria-label", ScoreSheetFinderLabels.get("clear"));
        $clear.html("&times;");
        const $icon = $('<span class="ssf-grid__filter-icon"></span>');
        $icon.attr("title", ScoreSheetFinderLabels.get("filter"));
        $icon.html(ScoreSheetFinderResults.icon("filter"));
        const $control = $('<div class="ssf-grid__filter-control"></div>');
        $control.append($input).append($clear).append($icon);
        $cell.append($control);
        return $cell;
    }
    /** Reflects the order and the column filters held by the state on the header. */
    static renderHeaderState() {
        const store = ScoreSheetFinderResults.store;
        const sort = store.sort;
        ScoreSheetFinderResults.$header
            .find(".ssf-grid__header")
            .each(function (index, element) {
            const $cell = $(element);
            const isSorted = (sort === null || sort === void 0 ? void 0 : sort.field) === $cell.attr("data-field");
            $cell.toggleClass("ssf-grid__header--sorted", isSorted);
            const $indicator = $cell.find(".ssf-grid__sort-indicator");
            if (!$indicator.length) {
                return;
            }
            $indicator.html(isSorted
                ? ScoreSheetFinderResults.icon(sort.direction === "desc" ? "sort-desc" : "sort-asc")
                : "");
        });
        const title = store.columnFilters.Title;
        const $input = ScoreSheetFinderResults.$header.find('.ssf-grid__filter-input[data-field="Title"]');
        if (!$input.length) {
            return;
        }
        const value = (title === null || title === void 0 ? void 0 : title.value) == null ? "" : title.value.toString();
        // Writing while the user types would move the caret, so the input is only
        // corrected when it no longer matches the state.
        if ($input.val() !== value) {
            $input.val(value);
        }
        $input
            .closest(".ssf-grid__filter-control")
            .toggleClass("ssf-grid__filter-control--active", value !== "");
    }
    // ------------------------------------------------------------------- rows
    static renderRows(results) {
        const $body = ScoreSheetFinderResults.$body;
        if (!$body.length) {
            return;
        }
        const selectedIds = ScoreSheetFinderResults.store.selectedIds;
        const rows = [];
        results.forEach(function (result) {
            const $row = $('<tr class="ssf-grid__row"></tr>');
            $row.attr("data-scoresheet-id", result.Id);
            $row.toggleClass("ssf-grid__row--selected", selectedIds.indexOf(result.Id) > -1);
            ScoreSheetFinderResults.columns.forEach(function (column) {
                $row.append(ScoreSheetFinderResults.buildCell(column, result));
            });
            rows.push($row[0]);
        });
        $body.empty().append(rows);
    }
    static buildCell(column, result) {
        const $cell = $("<td></td>");
        $cell.addClass(`ssf-grid__cell ssf-grid__cell--${column.field}`);
        switch (column.field) {
            case "NbPlayers":
                $cell.append(ScoreSheetFinderResults.buildValueWithIcon("user", ScoreSheetFinderResults.text(result.NbPlayers)));
                break;
            case "NbGames": {
                // A score sheet based on a race to has a maximum number of games.
                const games = ScoreSheetFinderResults.text(result.NbGames);
                const value = result.GameRowsAreDynamic
                    ? `${ScoreSheetFinderLabels.get("upTo")} ${games}`
                    : games;
                $cell.append(ScoreSheetFinderResults.buildValueWithIcon("calendar", value));
                break;
            }
            case "actions":
                $cell.append(ScoreSheetFinderResults.buildActions(result));
                break;
            default:
                $cell.text(ScoreSheetFinderResults.text(result[column.field]));
                break;
        }
        return $cell;
    }
    static buildValueWithIcon(name, value) {
        const $value = $('<div class="ssf-grid__cell-value"></div>');
        $value.append($('<span class="ssf-grid__cell-icon"></span>').html(ScoreSheetFinderResults.icon(name)));
        $value.append($("<span></span>").text(value));
        return $value;
    }
    /** Preview then Select: the secondary action, then the main one. */
    static buildActions(result) {
        const $preview = $('<button type="button"></button>');
        $preview.addClass("ssf-button ssf-button--outline ssf-results__preview");
        $preview.attr("data-scoresheet-id", result.Id);
        $preview.text(ScoreSheetFinderLabels.get("preview"));
        const $actions = $('<div class="ssf-results__actions"></div>').append($preview);
        if (!ScoreSheetFinder.selectable) {
            return $actions;
        }
        const $select = $('<button type="button"></button>');
        $select.addClass("ssf-button ssf-button--primary ssf-results__select");
        $select.attr("data-scoresheet-id", result.Id);
        $select.text(ScoreSheetFinderLabels.get("select"));
        return $actions.append($select);
    }
    // ------------------------------------------------------------------ cards
    /**
     * Prepares the cards for a new result set. The cards show the whole collection, a
     * chunk at a time as the user scrolls, so a new result set starts back from the top.
     */
    static renderCards(results) {
        const $cards = ScoreSheetFinderResults.$cards;
        if (!$cards.length) {
            return;
        }
        ScoreSheetFinderResults.cardsResults = results;
        ScoreSheetFinderResults.renderedCards = 0;
        ScoreSheetFinderResults.cardsAreStale = true;
        $cards.find(".ssf-card").remove();
        $cards.scrollTop(0);
        if (ScoreSheetFinderResults.store.filters.format.value !== "cards") {
            // Every card loads a thumbnail, so they wait until they are asked for.
            return;
        }
        ScoreSheetFinderResults.cardsAreStale = false;
        ScoreSheetFinderResults.renderNextCards();
    }
    /** Adds the next chunk of cards, if there is anything left to add. */
    static renderNextCards() {
        const $cards = ScoreSheetFinderResults.$cards;
        if (!$cards.length) {
            return;
        }
        const results = ScoreSheetFinderResults.cardsResults;
        const from = ScoreSheetFinderResults.renderedCards;
        if (from >= results.length) {
            return;
        }
        const to = Math.min(from + ScoreSheetFinderResults.cardsChunkSize, results.length);
        const cards = [];
        for (let i = from; i < to; i++) {
            cards.push(ScoreSheetFinderResults.buildCard(results[i])[0]);
        }
        // The empty state lives in the same container, so the cards go before it.
        const $emptyState = $cards.find(".scoresheet-finder__empty-state-message");
        if ($emptyState.length) {
            $emptyState.before(cards);
        }
        else {
            $cards.append(cards);
        }
        ScoreSheetFinderResults.renderedCards = to;
    }
    static buildCard(result) {
        const $card = $('<div class="ssf-card"></div>');
        $card.attr("data-scoresheet-id", result.Id);
        const $heading = $('<div class="ssf-card__heading"></div>');
        $heading.append($('<div class="ssf-card__title"></div>').text(ScoreSheetFinderResults.text(result.Title)));
        $heading.append($('<div class="ssf-card__subtitle"></div>').text(ScoreSheetFinderResults.getUsedTimesLabel(result)));
        const $header = $('<div class="ssf-card__header"></div>');
        $header.append($('<div class="ssf-card__avatar"></div>').text(ScoreSheetFinderResults.text(result.Id)));
        $header.append($heading);
        $card.append($header);
        // The card shows the score sheet itself, and opens the preview when clicked.
        const $media = $('<img class="ssf-card__media" alt="" />');
        $media.attr("src", `/cdn/uploaded_files/scoresheetthumbnails/scoresheet-thumbnail-${result.Id}.png`);
        $media.attr("data-scoresheet-id", result.Id);
        $card.append($media);
        const $body = $('<div class="ssf-card__body"></div>');
        $body.append(ScoreSheetFinderResults.buildCardChip("user", `${ScoreSheetFinderResults.text(result.NbPlayers)} ${ScoreSheetFinderLabels.get("players")}`));
        $body.append(ScoreSheetFinderResults.buildCardChip("calendar", ScoreSheetFinderResults.getNbGamesLabel(result)));
        $body.append(ScoreSheetFinderResults.buildCardChip(undefined, `${ScoreSheetFinderResults.text(result.NbRounds)} ${ScoreSheetFinderLabels.get("rounds")}`));
        $card.append($body);
        const $actions = ScoreSheetFinderResults.buildActions(result);
        $actions.addClass("ssf-card__actions");
        $card.append($actions);
        return $card;
    }
    static buildCardChip(icon, value) {
        const $chip = $('<span class="ssf-card__chip"></span>');
        if (icon) {
            $chip.append($('<span class="ssf-card__chip-icon"></span>').html(ScoreSheetFinderResults.icon(icon)));
        }
        $chip.append($("<span></span>").text(value));
        return $chip;
    }
    static getUsedTimesLabel(result) {
        return `${ScoreSheetFinderLabels.get("used")} ${ScoreSheetFinderResults.text(result.InUseCount)} ${ScoreSheetFinderLabels.get("times").toLowerCase()}`;
    }
    /** Up to N games, N games or N game, depending on the score sheet. */
    static getNbGamesLabel(result) {
        const games = ScoreSheetFinderResults.text(result === null || result === void 0 ? void 0 : result.NbGames);
        const word = (result === null || result === void 0 ? void 0 : result.NbGames) > 1
            ? ScoreSheetFinderLabels.get("games")
            : ScoreSheetFinderLabels.get("game");
        if ((result === null || result === void 0 ? void 0 : result.GameRowsAreDynamic) && (result === null || result === void 0 ? void 0 : result.NbGames) > 1) {
            return `${ScoreSheetFinderLabels.get("upTo")} ${games} ${word.toLowerCase()}`;
        }
        return `${games} ${word.toLowerCase()}`;
    }
    // ------------------------------------------------------------------ pager
    /** Draws the pager itself. Only its values change afterwards. */
    static renderPagerShell() {
        const $pager = ScoreSheetFinderResults.$pager;
        if (!$pager.length) {
            return;
        }
        const $nav = $('<div class="ssf-pager__nav"></div>');
        $nav.append(ScoreSheetFinderResults.buildPagerButton("first"));
        $nav.append(ScoreSheetFinderResults.buildPagerButton("previous"));
        const $page = $('<div class="ssf-pager__page"></div>');
        $page.append($("<span></span>").text(ScoreSheetFinderLabels.get("page")));
        const $input = $('<input type="text" class="ssf-pager__input" inputmode="numeric" />');
        $input.attr("aria-label", ScoreSheetFinderLabels.get("page"));
        $page.append($input);
        $page.append($("<span></span>").text(ScoreSheetFinderLabels.get("of").toLowerCase()));
        $page.append($('<span class="ssf-pager__page-count"></span>'));
        $nav.append($page);
        $nav.append(ScoreSheetFinderResults.buildPagerButton("next"));
        $nav.append(ScoreSheetFinderResults.buildPagerButton("last"));
        $pager.empty().append($nav).append($('<div class="ssf-pager__info"></div>'));
    }
    static buildPagerButton(action) {
        const label = ScoreSheetFinderLabels.get(action);
        const $button = $('<button type="button" class="ssf-pager__button"></button>');
        $button.attr("data-page-action", action);
        $button.attr("title", label);
        $button.attr("aria-label", label);
        $button.html(ScoreSheetFinderResults.icon(action));
        return $button;
    }
    static renderPager(pageInfo) {
        const $pager = ScoreSheetFinderResults.$pager;
        if (!$pager.length) {
            return;
        }
        const $input = $pager.find(".ssf-pager__input");
        if ($input.length && $input.val() !== pageInfo.page.toString()) {
            $input.val(pageInfo.page);
        }
        $pager.find(".ssf-pager__page-count").text(pageInfo.pageCount);
        $pager
            .find(".ssf-pager__info")
            .text(pageInfo.total
            ? `${pageInfo.from} - ${pageInfo.to} ${ScoreSheetFinderLabels.get("of").toLowerCase()} ${pageInfo.total} ${ScoreSheetFinderLabels.get("scoreSheets").toLowerCase()}`
            : ScoreSheetFinderLabels.get("noItemsToDisplay"));
        $pager
            .find('[data-page-action="first"], [data-page-action="previous"]')
            .prop("disabled", pageInfo.page <= 1);
        $pager
            .find('[data-page-action="next"], [data-page-action="last"]')
            .prop("disabled", pageInfo.page >= pageInfo.pageCount);
    }
    // ------------------------------------------------------------ empty state
    /**
     * Shows the empty state inside the results themselves, so that the structure of the
     * popup never changes. Both formats share the same block, which follows the one
     * that is on screen.
     */
    static renderEmptyState(isEmpty) {
        const $emptyState = ScoreSheetFinderResults.$emptyState;
        if (!$emptyState.length) {
            return;
        }
        const $target = ScoreSheetFinderResults.store.filters.format.value === "cards"
            ? ScoreSheetFinderResults.$cards
            : ScoreSheetFinderResults.$grid;
        if ($target.length && !$emptyState.parent().is($target)) {
            $target.append($emptyState);
        }
        $emptyState.toggleClass("hiddenforced", !isEmpty);
    }
    // ----------------------------------------------------------------- events
    /**
     * Wires the results. Every handler is attached to a container the finder renders
     * once, so the rows and the cards can be redrawn as often as needed.
     */
    static bindEvents() {
        try {
            const $results = ScoreSheetFinderResults.$results;
            if (!$results.length) {
                throw new Error("Results are not defined");
            }
            $results.on("click", ".ssf-grid__header--sortable", function (e) {
                if ($(e.target).closest(".ssf-grid__resizer").length) {
                    return;
                }
                ScoreSheetFinderResults.onHeaderClick($(e.currentTarget));
            });
            $results.on("input", ".ssf-grid__filter-input", function (e) {
                ScoreSheetFinderResults.onColumnFilterChange($(e.currentTarget));
            });
            $results.on("click", ".ssf-grid__filter-clear", function (e) {
                const field = $(e.currentTarget).attr("data-field");
                const $input = $results.find(`.ssf-grid__filter-input[data-field="${field}"]`);
                $input.val("");
                ScoreSheetFinderResults.onColumnFilterChange($input);
            });
            $results.on("click", ".ssf-results__preview", function (e) {
                e.stopPropagation();
                ScoreSheetFinder.previewScoreSheet(Number($(e.currentTarget).attr("data-scoresheet-id")));
            });
            $results.on("click", ".ssf-results__select", function (e) {
                e.stopPropagation();
                ScoreSheetFinder.selectScoreSheet(Number($(e.currentTarget).attr("data-scoresheet-id")));
            });
            $results.on("click", ".ssf-card__media", function (e) {
                ScoreSheetFinder.previewScoreSheet(Number($(e.currentTarget).attr("data-scoresheet-id")));
            });
            $results.on("click", ".ssf-grid__row", function (e) {
                ScoreSheetFinderResults.onRowClick($(e.currentTarget), e);
            });
            $results.on("click", ".ssf-pager__button", function (e) {
                ScoreSheetFinderResults.onPagerButtonClick($(e.currentTarget).attr("data-page-action"));
            });
            $results.on("change", ".ssf-pager__input", function (e) {
                ScoreSheetFinderResults.onPagerInputChange($(e.currentTarget));
            });
            $results.on("keydown", ".ssf-pager__input", function (e) {
                if (e.key === "Enter") {
                    e.preventDefault();
                    ScoreSheetFinderResults.onPagerInputChange($(e.currentTarget));
                }
            });
            $results.on("click", ".scoresheet-finder__reset-filters-button", function () {
                ScoreSheetFinder.resetFilters();
            });
            ScoreSheetFinderResults.$cards.on("scroll", function (e) {
                ScoreSheetFinderResults.onCardsScroll($(e.currentTarget));
            });
            ScoreSheetFinderResults.bindColumnResize($results);
            ScoreSheetFinderResults.bindColumnReorder($results);
        }
        catch (error) {
            console.error("Error while binding the results events", error);
        }
    }
    /** Ordering cycles through ascending, descending and back to the server order. */
    static onHeaderClick($header) {
        try {
            const field = $header.attr("data-field");
            if (!field) {
                return;
            }
            const store = ScoreSheetFinderResults.store;
            const sort = store.sort;
            if ((sort === null || sort === void 0 ? void 0 : sort.field) !== field) {
                store.sort = { field: field, direction: "asc" };
            }
            else if (sort.direction === "asc") {
                store.sort = { field: field, direction: "desc" };
            }
            else {
                store.sort = undefined;
            }
            ScoreSheetFinderResults.render();
        }
        catch (error) {
            console.error("Error while sorting the results", error);
        }
    }
    /**
     * The filter of a column is a member of the state like any other filter, so it
     * survives a change of the toolbar instead of being discarded by it.
     */
    static onColumnFilterChange($input) {
        var _a;
        try {
            if ($input.attr("data-field") !== "Title") {
                return;
            }
            const store = ScoreSheetFinderResults.store;
            const value = ((_a = $input.val()) !== null && _a !== void 0 ? _a : "").toString();
            store.columnFilters.Title =
                value === "" ? undefined : { operator: "contains", value: value };
            store.page = 1;
            ScoreSheetFinderResults.render();
        }
        catch (error) {
            console.error("Error while filtering on a column", error);
        }
    }
    static onRowClick($row, e) {
        try {
            const id = Number($row.attr("data-scoresheet-id"));
            if (isNaN(id)) {
                return;
            }
            const store = ScoreSheetFinderResults.store;
            if (e.ctrlKey || e.metaKey) {
                const selected = store.selectedIds;
                const index = selected.indexOf(id);
                if (index > -1) {
                    selected.splice(index, 1);
                }
                else {
                    selected.push(id);
                }
            }
            else {
                store.selectedIds = [id];
            }
            ScoreSheetFinderResults.renderSelection();
        }
        catch (error) {
            console.error("Error while selecting a result", error);
        }
    }
    /** Selects a single row, the way previewing a score sheet does. */
    static selectRow(id) {
        try {
            ScoreSheetFinderResults.store.selectedIds = isNaN(id) ? [] : [id];
            ScoreSheetFinderResults.renderSelection();
        }
        catch (error) {
            console.error("Error while selecting a row", error);
        }
    }
    static renderSelection() {
        const selectedIds = ScoreSheetFinderResults.store.selectedIds;
        ScoreSheetFinderResults.$body
            .find(".ssf-grid__row")
            .each(function (index, element) {
            const $row = $(element);
            $row.toggleClass("ssf-grid__row--selected", selectedIds.indexOf(Number($row.attr("data-scoresheet-id"))) > -1);
        });
    }
    static onPagerButtonClick(action) {
        try {
            const store = ScoreSheetFinderResults.store;
            const pageInfo = store.getPageInfo(store.sortedResults.length);
            switch (action) {
                case "first":
                    store.page = 1;
                    break;
                case "previous":
                    store.page = Math.max(1, pageInfo.page - 1);
                    break;
                case "next":
                    store.page = Math.min(pageInfo.pageCount, pageInfo.page + 1);
                    break;
                case "last":
                    store.page = pageInfo.pageCount;
                    break;
                default:
                    return;
            }
            ScoreSheetFinderResults.render();
        }
        catch (error) {
            console.error("Error while paging through the results", error);
        }
    }
    static onPagerInputChange($input) {
        var _a;
        try {
            const store = ScoreSheetFinderResults.store;
            const page = parseInt(((_a = $input.val()) !== null && _a !== void 0 ? _a : "").toString(), 10);
            // An unusable page number falls back on the page that is already shown.
            store.page = isNaN(page) ? store.page : page;
            ScoreSheetFinderResults.render();
        }
        catch (error) {
            console.error("Error while changing the page", error);
        }
    }
    static onCardsScroll($cards) {
        try {
            const element = $cards[0];
            if (!element) {
                return;
            }
            const remaining = element.scrollHeight - element.scrollTop - element.clientHeight;
            if (remaining <= 200) {
                ScoreSheetFinderResults.renderNextCards();
            }
        }
        catch (error) {
            console.error("Error while scrolling through the cards", error);
        }
    }
    // -------------------------------------------------- resizing and ordering
    /** Lets the user resize a column by dragging the edge of its header. */
    static bindColumnResize($results) {
        let field = undefined;
        let startX = 0;
        let startWidth = 0;
        $results.on("pointerdown", ".ssf-grid__resizer", function (e) {
            var _a, _b, _c;
            const $header = $(e.currentTarget).closest(".ssf-grid__header");
            field = $header.attr("data-field");
            startX = e.pageX;
            startWidth = $header.outerWidth();
            // Dragging the edge must not start a reorder of the column.
            $header.attr("draggable", "false");
            // Capturing the pointer keeps the moves coming while the cursor wanders
            // outside of the thin handle it started on.
            const pointerId = (_a = e.originalEvent) === null || _a === void 0 ? void 0 : _a.pointerId;
            if (pointerId != null) {
                (_c = (_b = e.currentTarget).setPointerCapture) === null || _c === void 0 ? void 0 : _c.call(_b, pointerId);
            }
            e.preventDefault();
        });
        $results.on("pointermove", ".ssf-grid__resizer", function (e) {
            if (!field) {
                return;
            }
            ScoreSheetFinderResults.setColumnWidth(field, Math.max(50, startWidth + (e.pageX - startX)));
        });
        $results.on("pointerup pointercancel", ".ssf-grid__resizer", function (e) {
            if (!field) {
                return;
            }
            $(e.currentTarget).closest(".ssf-grid__header").attr("draggable", "true");
            field = undefined;
        });
    }
    static setColumnWidth(field, width) {
        const column = ScoreSheetFinderResults.columns.filter(function (item) {
            return item.field === field;
        })[0];
        if (!column) {
            return;
        }
        column.width = width;
        ScoreSheetFinderResults.$columns
            .find(`col[data-field="${field}"]`)
            .css("width", `${width}px`);
    }
    /** Lets the user reorder the columns by dragging their header. */
    static bindColumnReorder($results) {
        let draggedField = undefined;
        $results.on("dragstart", ".ssf-grid__header", function (e) {
            var _a, _b;
            draggedField = $(e.currentTarget).attr("data-field");
            (_b = (_a = e.originalEvent) === null || _a === void 0 ? void 0 : _a.dataTransfer) === null || _b === void 0 ? void 0 : _b.setData("text/plain", draggedField !== null && draggedField !== void 0 ? draggedField : "");
        });
        $results.on("dragover", ".ssf-grid__header", function (e) {
            if (draggedField) {
                e.preventDefault();
            }
        });
        $results.on("drop", ".ssf-grid__header", function (e) {
            e.preventDefault();
            ScoreSheetFinderResults.moveColumn(draggedField, $(e.currentTarget).attr("data-field"));
            draggedField = undefined;
        });
        $results.on("dragend", ".ssf-grid__header", function () {
            draggedField = undefined;
        });
    }
    static moveColumn(field, targetField) {
        try {
            if (!field || !targetField || field === targetField) {
                return;
            }
            const columns = ScoreSheetFinderResults.columns;
            const fields = columns.map(function (column) {
                return column.field;
            });
            const fromIndex = fields.indexOf(field);
            const toIndex = fields.indexOf(targetField);
            if (fromIndex < 0 || toIndex < 0) {
                return;
            }
            columns.splice(toIndex, 0, columns.splice(fromIndex, 1)[0]);
            ScoreSheetFinderResults.renderColumns();
            ScoreSheetFinderResults.render();
        }
        catch (error) {
            console.error("Error while moving a column", error);
        }
    }
    // ---------------------------------------------------------------- helpers
    /** Shows an empty cell rather than the absence of a value. */
    static text(value) {
        return value == null ? "" : value.toString();
    }
    static icon(name) {
        const paths = {
            user: "M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6zm0 1.5c-2.7 0-5 1.4-5 3.1V15h10v-2.4c0-1.7-2.3-3.1-5-3.1z",
            calendar: "M5 1v1.5h6V1h1.5v1.5H14V15H2V2.5h1.5V1H5zm7.5 5h-9v7.5h9V6z",
            filter: "M1.5 2.5h13L9.5 8.8v4.4l-3 1.5V8.8z",
            "sort-asc": "M8 4l4 5H4z",
            "sort-desc": "M8 12L4 7h8z",
            first: "M4 2h1.5v12H4zm8.5 0v12L6 8z",
            previous: "M11 2v12L4.5 8z",
            next: "M5 2l6.5 6L5 14z",
            last: "M10.5 2H12v12h-1.5zM3.5 2L10 8l-6.5 6z",
        };
        const path = paths[name];
        if (!path) {
            return "";
        }
        return `<svg class="ssf-icon" viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="${path}" /></svg>`;
    }
}
/** Number of cards added every time the user reaches the bottom of the cards. */
ScoreSheetFinderResults.cardsChunkSize = 25;
/** Columns of the list, in the order the user put them in. */
ScoreSheetFinderResults.columns = [];
/** Whole collection the cards are drawn from, kept for the endless scrolling. */
ScoreSheetFinderResults.cardsResults = [];
/** Number of cards drawn so far. Goes back to zero on every new result set. */
ScoreSheetFinderResults.renderedCards = 0;
/**
 * Whether the cards still have to be drawn. Cards carry a thumbnail each, so they
 * are only drawn once the user actually asks for that format.
 */
ScoreSheetFinderResults.cardsAreStale = true;

//# sourceMappingURL=ScoreSheetFinderResults.js.map
